export default __webpack_public_path__ + "static/media/Head_3_Ear_3_C3.488a65b3.svg";